import { render, staticRenderFns } from "./unget-task.vue?vue&type=template&id=78bd4a34&"
import script from "./unget-task.vue?vue&type=script&lang=js&"
export * from "./unget-task.vue?vue&type=script&lang=js&"
import style0 from "./unget-task.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports